import React, { useEffect, useState } from "react";
import { api, fmtUSD } from "../../lib/api";
import { Users, Wallet, CreditCard, Landmark, Banknote, FileCheck2 } from "lucide-react";

const AdminMetrics = () => {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/admin/metrics").then(({ data }) => setM(data)); }, []);
  if (!m) return <div className="overline">Loading…</div>;

  const tiles = [
    { k: "Customers", v: m.total_customers, icon: Users },
    { k: "Accounts", v: m.total_accounts, icon: Wallet },
    { k: "Cards issued", v: m.total_cards, icon: CreditCard },
    { k: "Pending loans", v: m.pending_loan_applications, icon: FileCheck2 },
  ];
  const moneyTiles = [
    { k: "Total deposits", v: fmtUSD(m.total_deposits), icon: Banknote },
    { k: "Loan book", v: fmtUSD(m.loan_book_usd), icon: Landmark },
  ];

  return (
    <div className="space-y-10">
      <div>
        <div className="overline">Operator console</div>
        <h1 className="font-display text-4xl mt-1">System metrics</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[hsl(var(--border))] border border-[hsl(var(--border))]">
        {tiles.map((t) => (
          <div key={t.k} className="bg-[hsl(var(--surface))] p-6" data-testid={`tile-${t.k.toLowerCase().replace(/\s+/g, "-")}`}>
            <t.icon className="w-5 h-5 text-[hsl(var(--accent))]" />
            <div className="font-mono text-4xl mt-4">{t.v}</div>
            <div className="overline mt-2">{t.k}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[hsl(var(--border))] border border-[hsl(var(--border))]">
        {moneyTiles.map((t) => (
          <div key={t.k} className="bg-[hsl(var(--surface))] p-8" data-testid={`money-${t.k.toLowerCase().replace(/\s+/g, "-")}`}>
            <t.icon className="w-6 h-6 text-[hsl(var(--accent))]" />
            <div className="font-mono text-5xl mt-4">{t.v}</div>
            <div className="overline mt-2">{t.k}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminMetrics;
